(ns motorsaif.shared.subs
  (:require
   [motorsaif.data-utils :as data-utils]
   [motorsaif.i18n :as i18n]
   [motorsaif.shared.message-subs]
   [motorsaif.shared.ops-subs]
   [re-frame.core :as rf :refer [reg-sub]]))

(reg-sub :requests
  (fn [db _]
    (vals (get-in db [:requests]))))

(reg-sub :request
  (fn [db [_ id]]
    (let [?db-id (re-find #"\d{14,}" (str id))
          requests (vals (:requests db))
          ret (if ?db-id
                (get-in db [:requests (js/parseInt ?db-id)])
                (first (filter
                        #(= (:short/id %) id)
                        requests)))]
      ret)))

(reg-sub :current-owner-request
  (fn [db [_ id]]
    (get-in db [:current-owner-requests id])))

(reg-sub :current-owner-requests
  (fn [db _]
    (vals (:current-owner-requests db))))

(reg-sub :touches
  (fn [db _]
    (:touches db)))

(reg-sub :other-car-requests
  (fn [db [_ request-id]]
    (let [req @(rf/subscribe [:requests request-id])
          requests @(rf/subscribe [:requests])
          car-id (get-in req [:request/object :db/id])]
      (filter #(and
                (not= (:db/id %) request-id)
                (= (get-in % [:request/object :db/id] %) car-id)) requests))))

(reg-sub :public-profile
  (fn [db [_ id]]
    (get-in db [:businesses id])))

(reg-sub :feed-filters
  (fn [db _]
    (:feed-filters db)))

(reg-sub :env
  (fn [db _]
    (:env db)))

(reg-sub :online-users
  (fn [db _]
    (:online-users db)))

(reg-sub :user-online-state
  :<- [:current-owner-id]
  :<- [:online-users]
  (fn [[current-owner-id users] [_ id]]
    (when (not= current-owner-id id)
      (some
       (fn [[s v]]
         (when (s id) v))
       users))))

(reg-sub :user-last-seen
  (fn [db [_ id]]
    (get-in db [:last-seen id])))

(reg-sub :verification
  (fn [db _]
    (:verification db)))

(reg-sub :client-msgs
  (fn [db _]
    (vec (or (:client-msgs db) []))))

(reg-sub :ws-open?
  (fn [db _]
    (when-let [s (:state (:ws-state db))]
      (:open? @s))))

(reg-sub :build
  (fn [db _]
    (:build db)))

(reg-sub :dict
  (fn [db _]
    (data-utils/deep-merge i18n/default-dict
                           (:dict db))))

(reg-sub :business-roles
  :<- [:roles]
  (fn [roles _]
    (filter
     (fn [[_ {ident :db/ident}]]
       (not= ident :admin))
     roles)))

(reg-sub :current-owner-id
  (fn [db _]
    (or (:current-owner-id db)
        (:db/id (:user db)))))

(reg-sub :current-role-id
  (fn [db _]
    (let [roles (:roles db)
          current-owner (:current-owner-id db)
          user-id (:db/id (:user db))]
      (-> (filter (fn [[role _biz]]
                    (let [{:role/keys [target owner]} role]
                      (and
                       (= (:db/id owner) user-id)
                       (= (:db/id target) current-owner)))) roles)
          ffirst
          :db/id))))

(reg-sub :current-owner
  :<- [:user]
  :<- [:roles]
  :<- [:current-owner-id]
  (fn [[user roles id] _]
    (or (-> (filter #(= (get-in % [0 :role/target :db/id]) id) roles)
            first last)
        user)))

(reg-sub :is-admin?
  :<- [:roles]
  (fn [roles _]
    (some
     (fn [[_ {ident :db/ident}]]
       (= ident :admin))
     roles)))

(reg-sub :is-business?
  :<- [:current-owner]
  (fn [current-owner _]
    (some? (:business/name current-owner))))

(reg-sub :makes-models
  (fn [db [_ ?make]]
    (if ?make
      (get-in db [:makes-models ?make])
      (get-in db [:makes-models]))))

(reg-sub :user-cars
  (fn [db [_ id]]
    (if id
      (first (filter #(= (:db/id %) id) (:user-cars db)))
      (:user-cars db))))

(reg-sub :businesses
  (fn [db [_ id]]
    (if id
      (get-in db [:businesses id])
      (vals (:businesses db)))))

(reg-sub :roles
  (fn [db [_ id]]
    (:roles db)))

(reg-sub :ajax-status
  (fn [db [_ req-id]]
    (let [{:keys [fetched fetching error]} (get-in db [:ajax-status req-id])]
      (cond error
            :error
            (or
             (and fetching (not fetched))
             (> fetching fetched))
            :fetching
            (and fetching fetched)
            :fetched
            :else
            nil))))

(reg-sub :forms
  (fn [db _]
    (:forms db)))

(reg-sub :form-data
  (fn [db [_ form-key path]]
    (get-in db (apply conj [:forms form-key] path))))

(reg-sub :all-ajax-loaded?
  (fn [db [_ & req-keys]]
    (let [data (:ajax-status db)]
      (every? #(not (nil? %)) (map
                               #(get-in data [% :fetched])
                               req-keys)))))

(reg-sub :tags
  (fn [db [_ kind]]
    (-> (get-in db [:tags])
        (cond->> kind
          (filter #(= (:tag/type %) kind))))))

(reg-sub :locations
  (fn [db _]
    (get-in db [:locations])))

(reg-sub :current-owner-active-requests
  (fn [db _]
    (filter
     #(= (-> % :request/status :db/ident) :active)
     (vals (:current-owner-requests db)))))

(reg-sub :current-owner-history-requests
  (fn [db _]
    (filter
     #(#{:resolved :expired} (-> % :request/status :db/ident))
     (vals (:current-owner-requests db)))))

(reg-sub :user
  (fn [db _]
    (:user db)))

(reg-sub :ajax-errors
  (fn [db _]
    (filter (fn [[_ v]]
              (:error v))
            (:ajax-status db))))

(reg-sub :push-clients
  (fn [db _]
    (:clients db)))

(reg-sub :ui-state
  (fn [db & [k-path]]
    (get-in db (apply conj [:ui-state] (rest k-path)))))

;; Data from Redis
(reg-sub :current-interaction-status
  (fn [db [_ thread-id]]
    (->> (get-in db [:interaction-status thread-id])
         (filter
          (fn [itm]
            (= thread-id (get-in itm [:value :meta :thread-id]))))
         (map
          (fn [{:keys [value]}]
            (let [audit-user-id (get-in value [:meta :audit-user-id])
                  ret (assoc (:data value)
                             :audit-user-id audit-user-id)]
              ret)))
         (sort-by :date >)
         first)))


(comment
  (:interaction-status @re-frame.db/app-db)
  {:label "Completed",
   :date #inst "2025-07-13T12:32:35.479-00:00",
   :audit-user-id 17592186045449}
  @(rf/subscribe [:current-interaction-status [17592186060990 17592186055972]]))
